var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.17 20.37-4.53-4.53a5.548 5.548 0 0 1-1.61-4.17l.24-5c.11-2.39 2-4.28 4.4-4.4l5-.24c1.55-.06 3.07.51 4.17 1.61l4.53 4.53a5.535 5.535 0 0 1 0 7.81l-4.39 4.39a5.535 5.535 0 0 1-3.91 1.61c-1.41 0-2.83-.54-3.9-1.61zm1.06-1.07c.76.76 1.77 1.18 2.84 1.18 1.07 0 2.08-.42 2.84-1.18l4.39-4.39c.76-.76 1.18-1.77 1.18-2.84 0-1.07-.42-2.08-1.18-2.84L14.77 4.7c-.8-.8-1.91-1.23-3.03-1.17l-5 .24c-1.63.07-2.9 1.34-2.98 2.96l-.24 5c-.05 1.13.38 2.24 1.18 3.04l4.53 4.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.5c0-1.79 1.46-3.25 3.25-3.25s3.25 1.46 3.25 3.25-1.46 3.25-3.25 3.25-3.25-1.46-3.25-3.25zm1.5 0c0 .96.79 1.75 1.75 1.75s1.75-.79 1.75-1.75-.79-1.75-1.75-1.75-1.75.79-1.75 1.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTag);
export default __webpack_public_path__ + "static/media/vuesax-outline-tag.736c122fcb18e6829654de5322ba4e22.svg";
export { ForwardRef as ReactComponent };